import React, { useContext } from "react";
import Context from "../OriginStoryProvider";

const SquareImg2 = () => {
	const {
		data: { content },
	} = useContext(Context);

	return (
		<div className="chapter-2__square-img--2 main-grid">
			<div className="main-grid__margin"></div>
			<figure className="main-grid__body">
				<img
					className="chapter-2__square-img--2__img bg-shape"
					sizes="(max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 800px) 800px, (max-width: 1000px) 1000px, (min-width: 1001px) 1200px"
					srcSet={`${mainScript.assetPath}images/webp/chapter-2/norton-homestead-1893-arrow-400w.webp 400w, ${mainScript.assetPath}images/webp/chapter-2/norton-homestead-1893-arrow-600w.webp 600w, ${mainScript.assetPath}images/webp/chapter-2/norton-homestead-1893-arrow-800w.webp 800w, ${mainScript.assetPath}images/webp/chapter-2/norton-homestead-1893-arrow-1000w.webp 1000w, ${mainScript.assetPath}images/webp/chapter-2/norton-homestead-1893-arrow-1200w.webp 1200w`}
					src={`${mainScript.assetPath}images/jpg/chapter-2/norton-homestead-1893-arrow.jpg`}
					alt={content.chapters.second.square_img_2.img_alt}
					width="1440"
					height="1080"
					loading="lazy"
				/>
				<figcaption className="chapter-2__square-img--2__caption">
					<p className="img-caption">
						{content.chapters.second.square_img_2.img_caption}
					</p>
				</figcaption>
			</figure>
			<div className="main-grid__margin"></div>
		</div>
	);
};

export default SquareImg2;
